import api from './api';

export const taskStatusService = {
  getAll: async (projectId) => {
    const response = await api.get('/task-statuses', { params: { projectId } });
    return response.data;
  },

  create: async (data) => {
    const response = await api.post('/task-statuses', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/task-statuses/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/task-statuses/${id}`);
    return response.data;
  },

  reorder: async (projectId, statusIds) => {
    const response = await api.post('/task-statuses/reorder', { projectId, statusIds });
    return response.data;
  },
};
